import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';

import Image from '../Image';
import VisualizerClearAllButton from '../VisualizerClearAllButton/VisualizerClearAllButton';

import { IconEnlarge, IconCollapse, IconError } from '../Icons';

import { getBedVisualizerImages } from '../../Utils/VisualizerUtils';

import { StyledVisualizerWrapper, StyledImages, StyledImageWrapper, StyledIconWrapper, StyledErrorMessage } from './BedVisualizerGalleryStyles';

var _ref = React.createElement(
  StyledImageWrapper,
  { type: 'base-image' },
  React.createElement(Image, {
    alt: 'No visualizer items selected',
    src: 'https://cdn.shopify.com/s/files/1/1765/3959/files/dormify-visualizer-base-image.jpg?233083'
  })
);

var // only show if there are no sheets selected
_ref2 = React.createElement(
  Fragment,
  null,
  React.createElement(
    StyledImageWrapper,
    { type: 'base-pillow' },
    React.createElement(Image, {
      alt: 'pillow-default',
      src: 'https://cdn.shopify.com/s/files/1/1765/3959/files/pillow-compressor.png?271481'
    })
  ),
  React.createElement(
    StyledImageWrapper,
    { type: 'base-sheet' },
    React.createElement(Image, {
      alt: 'sheet-default',
      src: 'https://cdn.shopify.com/s/files/1/1765/3959/files/sheet-compressor.png?271481'
    })
  )
);

var _ref3 = React.createElement(IconCollapse, null);

var _ref4 = React.createElement(IconEnlarge, null);

var BedVisualizerGallery = function BedVisualizerGallery(props) {
  var visualizerImages = useMemo(function () {
    return getBedVisualizerImages(props.selectedProducts, props.queryParams);
  }, [props.selectedProducts, props.queryParams]);

  var outOfStockCount = props.selectedProducts.filter(function (prod) {
    return !prod.availableForSale;
  }).length;

  var renderBaseBedImage = function renderBaseBedImage(selectedProducts) {
    var sheets = selectedProducts.filter(function (product) {
      return product.category === 'sheets';
    });
    return React.createElement(
      Fragment,
      null,
      _ref,
      !props.isStaging && outOfStockCount > 0 && React.createElement(
        StyledErrorMessage,
        null,
        React.createElement(IconError, { fill: '#FFFFFF' }),
        React.createElement(
          'p',
          null,
          outOfStockCount + ' of your items ' + (outOfStockCount > 1 ? 'are' : 'is') + ' now out of stock please select another\n              item.'
        )
      ),
      sheets.length === 0 && _ref2
    );
  };

  return React.createElement(
    StyledVisualizerWrapper,
    {
      className: 'visualizer',
      onClick: function onClick() {
        return props.setLargeThumbnail(!props.largeThumbnail);
      },
      stickyMobileGallery: props.stickyMobileGallery,
      largeThumbnail: props.largeThumbnail
    },
    React.createElement(
      StyledImages,
      null,
      renderBaseBedImage(props.selectedProducts),
      visualizerImages.length > 0 && visualizerImages.map(function (image) {
        return React.createElement(
          StyledImageWrapper,
          { key: image.type, type: image.type },
          React.createElement(Image, { alt: image.alt, src: image.img })
        );
      })
    ),
    React.createElement(
      StyledIconWrapper,
      {
        stickyMobileGallery: props.stickyMobileGallery,
        largeThumbnail: props.largeThumbnail
      },
      props.largeThumbnail ? _ref3 : _ref4
    ),
    React.createElement(VisualizerClearAllButton, {
      selectedProducts: props.selectedProducts,
      largeThumbnail: props.largeThumbnail,
      windowWidth: props.windowWidth,
      handleClearAll: props.handleClearAll
    })
  );
};

BedVisualizerGallery.propTypes = {
  selectedProducts: PropTypes.array.isRequired,
  stickyMobileGallery: PropTypes.bool,
  largeThumbnail: PropTypes.bool.isRequired,
  setLargeThumbnail: PropTypes.func.isRequired,
  handleClearAll: PropTypes.func.isRequired,
  windowWidth: PropTypes.number.isRequired,
  queryParams: PropTypes.string,
  isStaging: PropTypes.bool
};

export default BedVisualizerGallery;